package link.erpango.quip.core.factory

import androidx.compose.runtime.Composable
import androidx.lifecycle.ViewModelStoreOwner
import androidx.lifecycle.viewmodel.compose.viewModel
import link.erpango.quip.core.TokenRefreshManager
import link.erpango.quip.domain.usecases.IAuthUseCase
import link.erpango.quip.domain.usecases.IGarageUseCase
import link.erpango.quip.features.settings.SettingsViewModel

class SettingsFactory(
    private val authInteractor: IAuthUseCase,
    private val garageInteractor: IGarageUseCase,
    private val viewModelStoreOwner: ViewModelStoreOwner,
    private val tokenRefreshManager: TokenRefreshManager? = null
) : IFactory {

    // Singleton instance to ensure the same ViewModel is used everywhere
    // This is critical for sign out events to be observed correctly
    private val settingsViewModelInstance: SettingsViewModel by lazy {
        SettingsViewModel(authInteractor, garageInteractor, tokenRefreshManager)
    }

    @Composable
    fun createSettingsViewModel(): SettingsViewModel {
        return viewModel(viewModelStoreOwner) {
            settingsViewModelInstance
        }
    }

    fun createSettingsViewModelInstance(): SettingsViewModel {
        return settingsViewModelInstance
    }
}
